import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import { getHomeConfigurationMock, usefulLinksGetMock } from './mock';
import { homePath } from '../../utils/paths';

export default {
  getConfiguration: () => {
    if (shouldUseMock()) {
      return getHomeConfigurationMock();
    }
    return apiCall(`${baseUrl}${homePath}homepage/configuration`, 'GET');
  },
  usefulLinksGet: () => {
    if (shouldUseMock()) {
      return usefulLinksGetMock();
    }
    return apiCall(`${baseUrl}${homePath}useful_links`, 'GET');
  },
};
